// src/components/Facturas.jsx
import React, { useEffect, useState } from "react";
import clienteAxios from "../../axios";
import ModalConfirm from "../ModalConfirm";
import ModalAgregarFactura from "./ModalAgregarFactura"; // Modal para agregar nueva factura

const Facturas = ({ pagoId }) => {
    const [facturas, setFacturas] = useState([]);
    const [facturaSeleccionada, setFacturaSeleccionada] = useState(null);
    const [editandoFactura, setEditandoFactura] = useState(null);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [showAgregarFacturaModal, setShowAgregarFacturaModal] = useState(false);
    const [busqueda, setBusqueda] = useState("");


    // Obtener facturas asociadas a un pago específico
    const obtenerFacturas = async () => {
        try {
            const response = await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Listar",
                modulo: "facturas"
            });
            setFacturas(response.data.data[0].filter(factura => factura.pago_id === pagoId));
        } catch (error) {
            console.log(error);
        }
    };

    const handleBusqueda = (e) => {
        setBusqueda(e.target.value.toLowerCase());
    };

    const facturasFiltradas = facturas.filter((factura) => {
        return (
            factura.total.toString().toLowerCase().includes(busqueda) ||
            factura.detalles.toLowerCase().includes(busqueda)
        );
    });


    useEffect(() => {
        obtenerFacturas();
    }, [pagoId]);

    // Función para manejar la edición de una factura
    const editarFactura = (factura) => {
        setEditandoFactura(factura);
    };

    // Guardar los cambios de la factura editada
    const guardarFacturaEditada = async () => {
        try {
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Actualizar",
                modulo: "facturas",
                id: editandoFactura.id,
                pago_id: pagoId,
                total: editandoFactura.total,
                detalles: editandoFactura.detalles
            });
            setEditandoFactura(null);
            obtenerFacturas(); // Actualizar la lista de facturas
        } catch (error) {
            console.log(error);
        }
    };

    // Confirmar la eliminación de una factura
    const confirmarEliminarFactura = (factura) => {
        setFacturaSeleccionada(factura);
        setShowConfirmModal(true);
    };

    const eliminarFactura = async () => {
        try {
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Eliminiar",
                modulo: "facturas",
                id: facturaSeleccionada.id
            });
            setShowConfirmModal(false);
            obtenerFacturas(); // Actualizar la lista de facturas
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <div>

            {/* Modal para agregar una nueva factura */}
            <ModalAgregarFactura
                show={showAgregarFacturaModal}
                onClose={() => setShowAgregarFacturaModal(false)}
                pagoId={pagoId}
                onFacturaAgregada={obtenerFacturas} // Actualizar la lista tras agregar una nueva factura
            />

            <div className="mt-4 border p-4 rounded-lg">
                <h3 className="text-lg font-semibold">Facturas asociadas al Pago ID: {pagoId}</h3>


                {/* Barra de búsqueda */}
                <input
                    type="text"
                    placeholder="Buscar factura..."
                    value={busqueda}
                    onChange={handleBusqueda}
                    className="border rounded-lg p-2 mb-4 mt-2 w-1/2 min-w-[200px]"
                />


                {/* Botón para abrir el modal de agregar factura */}
                <button
                    onClick={() => setShowAgregarFacturaModal(true)}
                    className="bg-blue-500 text-white rounded px-4 py-2 mt-4 ml-6 hover:bg-blue-400"
                >
                    Agregar Nueva Factura
                </button>



                <ul className="mt-4">
                    {facturasFiltradas.map((factura) => (
                        <li key={factura.id} className="border p-2 mb-2">
                            {editandoFactura && editandoFactura.id === factura.id ? (
                                <>
                                    <div className="flex flex-col">
                                        <h3 className="font-semibold">Total:</h3>
                                        <input
                                            type="number"
                                            value={editandoFactura.total}
                                            onChange={(e) =>
                                                setEditandoFactura({ ...editandoFactura, total: e.target.value })
                                            }
                                            className="border rounded-lg p-2 mb-2"
                                            maxLength={10}
                                        />

                                        <h3 className="font-semibold">Detalles:</h3>
                                        <input
                                            type="text"
                                            value={editandoFactura.detalles}
                                            onChange={(e) =>
                                                setEditandoFactura({ ...editandoFactura, detalles: e.target.value })
                                            }
                                            className="border rounded-lg p-2 mb-2"
                                            maxLength={50}
                                        />

                                        <div className="flex mt-4">
                                            <button
                                                onClick={guardarFacturaEditada}
                                                className="bg-green-500 text-white rounded px-2 py-1 mr-2 w-40"
                                            >
                                                Guardar
                                            </button>
                                            <button
                                                onClick={() => setEditandoFactura(null)}
                                                className="bg-gray-500 text-white rounded px-2 py-1 w-40"
                                            >
                                                Cancelar
                                            </button>
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <span><strong>Total:</strong> ${factura.total}</span><br />
                                    <span><strong>Detalles:</strong> {factura.detalles}</span><br />
                                    <button
                                        onClick={() => editarFactura(factura)}
                                        className="bg-gray-500 text-white rounded px-2 py-1 mt-2 hover:bg-gray-400"
                                    >
                                        Editar
                                    </button>
                                    <button
                                        onClick={() => confirmarEliminarFactura(factura)}
                                        className="bg-red-600 text-white rounded px-2 py-1 mt-2 ml-2 hover:bg-red-500"
                                    >
                                        Eliminar
                                    </button>
                                </>
                            )}
                        </li>
                    ))}
                </ul>

                {/* Modal de confirmación para eliminar una factura */}
                <ModalConfirm
                    show={showConfirmModal}
                    message="¿Estás seguro de que quieres eliminar esta factura?"
                    onConfirm={eliminarFactura}
                    onCancel={() => setShowConfirmModal(false)}
                />


            </div>
        </div>
    );
};

export default Facturas;
